export default __webpack_public_path__ + "static/media/keyboard.9a25461c.mp3";